import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { PlanResource } from 'dy-frontend-http-repository/lib/modules/Plan/resources';
import domain from './domain';
import { resetPlans } from './events';

// Plans
export const $plans = domain.createStore<CollectionResource<PlanResource, {}> | null>(null).reset(resetPlans);
